import { render, staticRenderFns } from "./CustomerStatement.vue?vue&type=template&id=ddd85360&scoped=true&"
import script from "./CustomerStatement.vue?vue&type=script&lang=js&"
export * from "./CustomerStatement.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStatement.vue?vue&type=style&index=0&id=ddd85360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd85360",
  null
  
)

export default component.exports